<template>
  <div>
    <FormContainer>
      <form class="border p-8 rounded shadow-2xl" @submit="handleSubmit">
        <div class="mb-3">
          <label class="form-label form-required"> Header </label>
          <input
            type="text"
            v-model="form.header"
            class="form-input"
            placeholder="Title of article"
            required
          />
        </div>

        <div class="mb-3">
          <label class="form-label"> Vimeo URL (optional) </label>
          <input
            type="url"
            v-model="form.link"
            class="form-input"
            placeholder="URL of video"
          />
        </div>

        <div class="mb-3">
          <div class="flex justify-between">
            <label class="form-label"> Name(s) of author </label>
            <a
              href="https://www.markdownguide.org/basic-syntax/"
              target="_blank"
            >
              <p class="font-bold mb-2 text-STorange hover:underline">
                Supports Markdown
              </p>
            </a>
          </div>
          <textarea
            type="text"
            rows="2"
            v-model="form.author"
            class="form-input"
            placeholder="Name(s) of author"
          />
        </div>

        <div class="mb-3">
          <div class="flex justify-between">
            <label class="form-label"> Body </label>
            <a
              href="https://www.markdownguide.org/basic-syntax/"
              target="_blank"
            >
              <p class="font-bold mb-2 text-STorange hover:underline">
                Supports Markdown
              </p>
            </a>
          </div>
          <textarea
            type="text"
            rows="4"
            v-model="form.body"
            class="form-input"
            placeholder="Body of article"
          />
        </div>

        <div class="border-t-2 my-5"></div>

        <p class="text-lg mb-3">For ShotTrackers home page (slider):</p>

        <div v-if="!imageUploaded">
          <div class="mb-3">
            <label class="form-label"> Upload image (optional) </label>
            <input
              class="form-input"
              type="file"
              accept="image/*"
              @change="getImage"
            />
          </div>

          <div class="mb-3" :class="imagePresent ? 'null' : 'opacity-40'">
            <label class="form-label">Display on slider</label>
            <div class="form-input space-x-3">
              <span>Featured</span>
              <input
                class="cursor-pointer"
                type="checkbox"
                v-model="form.homeFeatured"
                :disabled="!imagePresent"
              />
            </div>
          </div>

          <div :class="imagePresent ? 'null' : 'opacity-40'">
            <label class="form-label"
              >Article preview (Displayed on home page)
            </label>
            <input
              type="text"
              v-model="form.subheader"
              class="form-input"
              placeholder="Article preview"
              :disabled="!imagePresent"
            />
          </div>
        </div>

        <div v-else>
          <div class="mb-3">
            <label class="form-label">Display on home page</label>
            <div class="form-input space-x-3">
              <span>Featured</span>
              <input
                class="cursor-pointer"
                type="checkbox"
                v-model="form.homeFeatured"
              />
            </div>
          </div>

          <div>
            <label class="form-label"
              >Article preview (Displayed on home page)
            </label>
            <input
              type="text"
              v-model="form.subheader"
              class="form-input"
              placeholder="Article preview"
            />
          </div>
        </div>

        <button class="mt-4 py-2 px-3 bg-STblue text-white w-full rounded">
          Submit
        </button>
      </form>

      <ArticlePreview :form="form" />
    </FormContainer>

    <div class="mt-10" v-if="form.header">
      <p class="text-lg">How it will be displayed on the news page</p>
      <Article
        class="mt-5"
        :header="form.header"
        :author="form.author"
        :previewMode="true"
      />
    </div>
  </div>
</template>

<script>
import ArticlePreview from "./ArticlePreview.vue";
import Article from "./Article.vue";
import FormContainer from "../../FormContainer.vue";

export default {
  name: "ArticleForm",

  props: {
    form: Object,
    imageUploaded: String,
  },

  data() {
    return {
      imagePresent: false,
    };
  },

  components: {
    FormContainer,
    ArticlePreview,
    Article,
  },

  methods: {
    getImage(e) {
      this.imagePresent = this.form.image = e.target.files[0];
    },

    handleSubmit(e) {
      e.preventDefault();

      this.$emit("handleSubmit");
    },
  },
};
</script>
